module.exports = __webpack_public_path__ + "static/media/xk.d99e82f3.webp";